import { AppProvider } from './provider';
import { AppRouter } from './router';

import SnackbarCommon from '@/components/layouts/snackbar-common';
import ConfirmDialog from '@/components/layouts/confirm-dialog';
import LoadingCommon from '@/components/layouts/loading-common';

export const App = () => {
  return (
    <AppProvider>
      <AppRouter />
      <ConfirmDialog />
      <SnackbarCommon />
      <LoadingCommon />
    </AppProvider>
  );
};
